export const ARCHON_ROOT = '/archon';
export const ARCHON_TASKS_COSTS_PATH = `${ARCHON_ROOT}/tasks-costs`;
export const ARCHON_ACCURACY_PATH = `${ARCHON_ROOT}/accuracy`;
export const ARCHON_CAMERAS_PATH = `${ARCHON_ROOT}/cameras`;
export const ARCHON_MATCH_TRACE_PATH = `${ARCHON_ROOT}/match-trace`;
export const ARCHON_DATA_ROLLOUT_PATH = `${ARCHON_ROOT}/data/rollout-schedules`;
export const ARCHON_DATA_INVOICES_PATH = `${ARCHON_ROOT}/data/invoices`;
export const ARCHON_DATA_COST_MODEL_PATH = `${ARCHON_ROOT}/data/cost-model`;
export const ARCHON_DATA_INGRESS_SOURCES_PATH = `${ARCHON_ROOT}/data/ingress-sources`;
export const ARCHON_DATA_QA_SAMPLING_PATH = `${ARCHON_ROOT}/data/qa-sampling`;
/** Kit showcase: reachable by URL, deliberately out of the navigation. */
export const ARCHON_KIT_PATH = `${ARCHON_ROOT}/kit`;
